import { booleanToCallback, createValidatorAllowingFailureMessageOverride } from '@clocklimited/validity'
import moment from 'moment-timezone'

export default createValidatorAllowingFailureMessageOverride(booleanToCallback(val => {
  const dateString = val.trim()
  const date = moment(dateString, 'DD MMMM YYYY')
  return date.isValid()
}), `This must be a valid date!`)
